// FileUploadVariants.js
export default {
    // Default variant - Horizontal layout
    default: {
      root: "mb-4 w-full",
      container: "flex flex-row gap-2 items-center justify-start",
      button: "",
      label: "block font-medium text-text_secondary",
      fileNames: "flex-grow ml-2",
      error: "mt-1 text-error"
    },
  
    vertical: {
      root: "mb-4 w-full",
      container: "flex flex-col gap-2 items-start justify-start",
      button: "w-full",
      label: "block font-medium text-text_secondary mb-1",
      fileNames: "w-full mt-1",
      error: "mt-1 text-error w-full"
    },
  
    // Compact variant - Horizontal
    compact: {
      root: "mb-2 w-full",
      container: "flex flex-row gap-1.5 items-center justify-start",
      button: "text-sm py-1.5 px-3",
      label: "block text-xs font-medium text-text_secondary",
      fileNames: "flex-grow ml-1.5 text-xs",
      error: "mt-0.5 text-xs text-error"
    },
  
    // Compact vertical variant
    compact_vertical: {
      root: "mb-2 w-full",
      container: "flex flex-col gap-1 items-start justify-start",
      button: "text-sm py-1.5 px-3 w-full",
      label: "block text-xs font-medium text-text_secondary mb-0.5",
      fileNames: "w-full text-xs mt-0.5",
      error: "mt-0.5 text-xs text-error w-full"
    },

    // Large variant - Horizontal
    large: {
      root: "mb-6 w-full",
      container: "flex flex-row gap-3 items-center justify-start",
      button: "text-lg py-3 px-5",
      label: "block text-base font-medium text-text_secondary",
      fileNames: "flex-grow ml-3 text-base",
      error: "mt-1.5 text-base text-error"
    },
  
    // Large vertical variant
    large_vertical: {
      root: "mb-6 w-full",
      container: "flex flex-col gap-3 items-start justify-start",
      button: "w-full text-lg py-3 px-5",
      label: "block text-base font-medium text-text_secondary mb-1.5",
      fileNames: "w-full text-base mt-1.5",
      error: "w-full text-base text-error mt-1.5"
    },
  
    // Admin variants -------------------------------------------------------
    admin: {
      root: "mb-4 w-full",
      container: "flex flex-row gap-2 items-center justify-start",
      button: "",
      label: "block font-medium text-admin_text_secondary",
      fileNames: "flex-grow ml-2",
      error: "mt-1 text-admin_error"
    },
  
    admin_vertical: {
      root: "mb-4 w-full",
      container: "flex flex-col gap-2 items-start justify-start",
      button: "w-full",
      label: "block font-medium text-admin_text_secondary mb-1",
      fileNames: "w-full text-admin_text_secondary mt-1",
      error: "mt-1 text-admin_error w-full"
    },
  }